import React from 'react';
import { TabelaRotas } from '../../components/TabelaRotas';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';


export default function RotasPage() {

  return (
    <div className="p-pt-0">
      <MenuMain >
        <TabelaRotas />
      </MenuMain>
      <AppFooter />
    </div>
  );
}
